module.exports = __webpack_public_path__ + "static/bg02-d276f92fe20d8244fe08f57824584c77.png";